import { TokenService } from "./storageService";

const AuthService = {

    sess: null,
    modules: null,
    keys: null,
    // module: null,
    // submodules: null,
    // submodule: null,

    load() {
        this.sess = TokenService.getSession();
        this.modules = this.sess.role.modules;
        this.keys = Object.keys(this.modules);
    },

    module(module) {
        this.load();
        let access = false;

        if (this.keys.indexOf(module) > -1) {
            if (this.modules[module].access) {
                access = true;
            }
        }
        // console.log(`[FN] module (${module}):`, access);
        return access;
    },

    submodule(module, submodule, redirect) {
        let access = false;
        // console.log(`[FN] submodule: ${module}, ${submodule}, ${redirect}`);
        if (this.module(module)) {
            // console.log(this.modules);
            if (submodule) {
                access = this.modules[module].submodules.some(submod => ((submod.controller.toLowerCase().replace(new RegExp(module, 'gi'), '') == submodule.toLowerCase().replace(new RegExp(module, 'gi'), '')) && (submod.access)));
            } else if (this.modules[module].submodules[0].access || redirect) {
                access = true;
            }
        }

        // console.log(`[FN] submodule (${module}, ${submodule}, ${redirect}):`, access);
        return access;
    },

    redirect(module) {
        let rd = false;

        this.modules[module].submodules.forEach(submod => {
            if (submod.access && rd === false) {
                rd = submod.controller;
                // console.log('rd:', rd);
                rd = rd.replace(new RegExp(module, 'gi'), '');
                // console.log('rd:', rd);
                rd = `${module}${rd}`;
                // console.log('rd:', rd);
            }
        });
        // console.log(`[FN] redirect (${module}):`, rd);
        return rd;
    },

    action(module, submodule, method) {
        this.load();

        let mod = this.modules[module]
        let submod = null;
        let access = false;

        if (this.isRoot()) {
            access = true;
        } else {
            if (submodule) {
                mod.submodules.forEach(sm => {
                    if (sm.controller.toLowerCase() === submodule.toLowerCase()) {
                        sm.methods.forEach(mt => {
                            // console.log(`[FN] action-submodule-methods: ${mt.name.toLowerCase()} === ${method.toLowerCase()}`);
                            if (mt.name.toLowerCase() === method.toLowerCase()) {
                                access = mt.access;
                            }
                        })

                        if (!access) {
                            sm.components.forEach(cp => {
                                // console.log(`[FN] action-submodule-components: ${cp.name.toLowerCase()} === ${method.toLowerCase()}`);
                                if (cp.name.toLowerCase() === method.toLowerCase()) {
                                    access = cp.access;
                                }
                            })
                        }
                    }
                })
            } else {
                mod.components.forEach(comp => {
                    if (comp.component.toLowerCase() == method.toLowerCase() && comp.access) {
                        // console.log(`[FN] action-components: ${comp.component.toLowerCase()} === ${method.toLowerCase()}`);
                        access = true;
                    }
                });
            }
        }

        // console.log(`[FN] action (${module}, ${submodule}, ${method}):`, access);
        return access;
    },

    isRoot() {
        this.load();

        if (this.sess.role.type == 'ROOT') {
            return true;
        } else {
            return false;
        }
    }
}

export { AuthService };
